import { MessageComponent } from '@syncfusion/ej2-react-notifications';
import { createSpinner, showSpinner } from '@syncfusion/ej2-popups';
import { useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import { checkForm, post } from '../utils/Api';
import { env } from '../env'
export default function FormSubmitted(props) {
    // Declare variables using const or let
    const { provider, request } = props;
    const navigate = useNavigate();
    const { search } = useLocation();
    let spinnerInstance = null;
    let isCheckingSubmit = false;

    // Declare state variables using useState
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitState, setSubmitState] = useState({
        result: null,
        submitErrorMessage: '',
        submitError: false
    })

    // Declare effects using useEffect
    useEffect(() => {
        document.title = 'CPA - Submitting';
    }, []);

    useEffect(() => {
        if (env.VITE_ENV && env.VITE_ENV.toLowerCase() !== 'production') {
            console.log(`FormSubmitted.useEffect :: isSubmitting: ${isSubmitting}`);
        }

        if (isSubmitting && spinnerInstance) {
            createSpinner({
                // Specify the target for the spinner to show
                target: spinnerInstance,
            });
            showSpinner(spinnerInstance);
        }
    }, [isSubmitting])

    useEffect(() => {
        if (env.VITE_ENV && env.VITE_ENV.toLowerCase() !== 'production') {
            console.log(`FormSubmitted.useEffect :: []`);
        }

        if (request !== null && !isCheckingSubmit) {
            handleSubmit(request);
        }
    }, [request]);

    // Declare event handlers or other functions
    const handleSubmit = async (saveRequest) => {
        if (env.VITE_ENV && env.VITE_ENV.toLowerCase() !== 'production') {
            console.log(`FormSubmitted.handleSubmit`);
        }

        if (!isSubmitting && !isCheckingSubmit && !hasSubmitted) {
            isCheckingSubmit = true;
            setIsSubmitting(true);
            var checkResponse = await checkForm(provider, saveRequest.fields['user']?.emailAddress);
            if (checkResponse.status === 200) {
                isCheckingSubmit = false;
                var submitResponse = await post(`${provider.url}/api/v1.0/forms/submit?cfk=${encodeURIComponent(provider.key)}`, saveRequest);
                setIsSubmitting(false);
                if (submitResponse.status === 201) {
                    setHasSubmitted(true);
                    setSubmitState((prevFormData) => ({ ...prevFormData, result: submitResponse.data, submitError: false, submitErrorMessage: "" }));
                    //navigate("/completed");
                    navigate({ pathname: "/completed", replace: false, preserveSearch: true, search });
                }  else {
                    setSubmitState((prevFormData) => ({ ...prevFormData, submitError: true, submitErrorMessage: "An error occured checking submission system, please refresh page to try again or contact your representative for support." }));
                    setIsSubmitting(false);
                    isCheckingSubmit = false;
                }
            } else if (checkResponse.status === 409) {
                //navigate("/completed");
                navigate({ pathname: "/alreadysubmitted", replace: false, preserveSearch: true, search });
            } else {
                setSubmitState((prevFormData) => ({ ...prevFormData, submitError: true, submitErrorMessage: "An error occured checking submission system, please refresh page to try again or contact your representative for support." }));
                setIsSubmitting(false);
                isCheckingSubmit = false;
            }
        }
    };

    return (
        <div>
            <div className="row">
                <div className="e-card">
                    <div className="e-card-header">
                        <div className="e-card-header-caption">
                            <div className="e-card-header-title"><h3>{isSubmitting ? 'Submitting...' : !submitState.submitError && submitState.result && submitState.result.isSuccess ? 'Success' : submitState.submitError ? "Unable to submit" : ""}</h3></div>
                        </div>
                    </div>
                    <div className="e-card-content">
                        <div className="col-xs-12 mt-2" style={isSubmitting ? {} : { display: 'none' }}>
                            <div ref={spinner => {
                                spinnerInstance = spinner;
                            }} id="spinner" />
                        </div>
                        <div className="col-xs-12 mt-2" style={!isSubmitting && submitState.submitError ? {} : { display: 'none' } }>
                            <MessageComponent severity="Warning" variant="Filled" content={submitState.submitErrorMessage}></MessageComponent >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
